import { useState, useCallback } from 'react'

export interface DeleteGroupModalData {
  id: string
  name: string
}

export interface UseDeleteGroupModalProps {
  onSuccess?: () => void
}

export function useDeleteGroupModal({ onSuccess }: UseDeleteGroupModalProps = {}) {
  const [modalData, setModalData] = useState<DeleteGroupModalData | null>(null)

  const openModal = useCallback((data: DeleteGroupModalData) => {
    setModalData(data)
  }, [])

  const closeModal = useCallback(() => {
    setModalData(null)
  }, [])

  return {
    isOpen: !!modalData,
    modalData,
    openModal,
    closeModal,
    onSuccess
  }
}
